import axios from 'axios';

import type { LoginResultViewModel } from '@/shared/api/generated/types/LoginResultViewModel';

/**
 * Instância Axios isolada para refresh token.
 *
 * Não usa `axiosInstance` nem os clientes gerados pelo Kubb,
 * quebrando o ciclo estático de dependência.
 */
const refreshInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    PartnerAuthorization: import.meta.env.VITE_PARTNER_AUTH,
  },
});

/** Resultado da renovação do token. */
export interface RefreshTokenResult {
  token: string;
  tokenExpireDate: Date;
}

/**
 * Realiza a chamada HTTP de refresh token diretamente,
 * sem passar pelo interceptor do `axiosInstance`.
 *
 * @param currentToken - Access token atual a ser renovado
 * @returns Novo access token e data de expiração
 * @throws Erro se a resposta não contiver um token válido
 */
export async function refreshAccessToken(currentToken: string): Promise<RefreshTokenResult> {
  const response = await refreshInstance.post<LoginResultViewModel>(
    '/api/v1/access/refreshtoken',
    undefined,
    {
      headers: {
        Authorization: `Bearer ${currentToken}`,
      },
    },
  );

  const newToken = response.data.token;
  if (!newToken) throw new Error('refresh_failed');

  return {
    token: newToken,
    tokenExpireDate: new Date(response.data.tokenExpireDate ?? ''),
  };
}
